/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsMutationRequest,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsPathParams,
} from "../../types/individualPaymentRenegotiationController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations.ts";
import { individualPaymentRenegotiationViewModelSchema } from "../individualPaymentRenegotiationViewModelSchema.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations200>;

/**
 * @description Regra de negócio violada
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsMutationRequestSchema =
  z.lazy(
    () => individualPaymentRenegotiationViewModelSchema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsMutationRequest>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiations200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidRenegotiationsMutationResponse>;
